/* Satruven: interacciones y animaciones del tema */
(() => {
  const design = !!(window.Shopify && Shopify.designMode);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---------- menú móvil ---------- */
  const burger = $('#burger');
  if (burger) {
    const toggle = open => { document.body.classList.toggle('menu-open', open); burger.setAttribute('aria-expanded', open); };
    burger.addEventListener('click', () => toggle(!document.body.classList.contains('menu-open')));
    $$('#mobileMenu a').forEach(a => a.addEventListener('click', () => toggle(false)));
  }

  /* ---------- FAQ ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('.qa button'); if (!b) return;
    const qa = b.parentElement, open = !qa.classList.contains('open');
    $$('.qa.open').forEach(o => { o.classList.remove('open'); o.querySelector('button').setAttribute('aria-expanded', false); });
    qa.classList.toggle('open', open); b.setAttribute('aria-expanded', open);
  });

  /* ---------- brillo que sigue al cursor en los planes ---------- */
  document.addEventListener('pointermove', e => {
    const p = e.target.closest && e.target.closest('.plan'); if (!p) return;
    const r = p.getBoundingClientRect();
    p.style.setProperty('--x', (e.clientX - r.left) + 'px');
    p.style.setProperty('--y', (e.clientY - r.top) + 'px');
  });

  /* ---------- piezas que se vuelven a montar si el editor recarga la sección ---------- */
  const initParts = (scope = document) => {
    const mq = $('#marquee', scope) || (scope.id === 'marquee' ? scope : null);
    if (mq && mq.dataset.logos) {
      const logos = mq.dataset.logos.split(',').map(x => x.trim()).filter(Boolean);
      const mk = () => logos.map(x => `<img src="https://cdn.simpleicons.org/${x}/edebe4" alt="${x}" loading="lazy" width="30" height="30" onerror="this.remove()">`).join('');
      mq.innerHTML = mk() + mk();
    }
    const pan = $('#pan', scope), dots = $('#panDots', scope);
    if (pan && dots) {
      const cards = $$('.svc', pan);
      dots.innerHTML = cards.map((_, i) => `<button type="button" aria-label="Service ${i + 1}"></button>`).join('');
      const btns = $$('button', dots);
      btns.forEach((d, i) => d.addEventListener('click', () => pan.scrollTo({ left: cards[i].offsetLeft - (pan.clientWidth - cards[i].offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' })));
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) btns.forEach((d, i) => d.classList.toggle('on', cards[i] === e.target)); }), { root: pan, threshold: 0.6 });
      cards.forEach(c => io.observe(c));
    }
    const flow = $('#flow', scope);
    if (flow && !flow.dataset.on) { flow.dataset.on = 1; initFlow(flow, reduce); }
  };
  initParts();
  document.addEventListener('shopify:section:load', e => initParts(e.target));

  /* ---------- barra fija de compra (producto, móvil) ---------- */
  const bar = $('#buybar'), buy = $('.pdp-buy');
  if (bar && buy) new IntersectionObserver(([e]) => bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(buy);

  /* ---------- selector de cantidad ---------- */
  document.addEventListener('click', e => {
    const d = e.target.closest('.qty [data-d]'); if (!d || d.closest('.cart')) return;
    const input = d.parentElement.querySelector('input'); if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +d.dataset.d);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ================= animaciones (GSAP) ================= */
  if (!window.gsap || design) {
    document.documentElement.classList.remove('js');
    const n = $('#nav'); if (n) n.classList.add('solid');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  let lenis;
  if (!reduce && window.Lenis) {
    lenis = new Lenis({ lerp: 0.1 });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  const scrollToEl = t => lenis ? lenis.scrollTo(t, { offset: -20, duration: 1.4 }) : t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]'); if (!a) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.hash.length < 2) return;
    const t = document.getElementById(url.hash.slice(1)); if (!t) return;
    e.preventDefault(); scrollToEl(t);
  });

  /* nav: fondo al bajar, se esconde al bajar y vuelve al subir */
  const nav = $('#nav');
  if (nav) ScrollTrigger.create({
    start: 0, end: 'max',
    onUpdate: self => {
      const y = self.scroll();
      if (!nav.dataset.fixedSolid) nav.classList.toggle('solid', y > 40);
      if (!document.body.classList.contains('menu-open') && !document.body.classList.contains('cart-open'))
        nav.classList.toggle('hide', self.direction === 1 && y > 300);
    }
  });

  const splitWords = (el, cls) => {
    const walk = node => [...node.childNodes].forEach(n => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.append(part); return; }
          const s = document.createElement('span'); s.className = cls; s.textContent = part; frag.append(s);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1) walk(n);
    });
    walk(el);
  };

  if (reduce) { gsap.set('[data-reveal]', { opacity: 1, y: 0 }); return; }

  /* hero */
  const h1 = $('.hero h1');
  if (h1) {
    splitWords(h1, 'w-in');
    $$('.w-in', h1).forEach(w => { const wr = document.createElement('span'); wr.className = 'word'; w.replaceWith(wr); wr.append(w); });
    gsap.set('.hero h1, [data-hero], [data-hero-visual]', { visibility: 'visible' });
    gsap.timeline({ defaults: { ease: 'expo.out' } })
      .from('.hero h1 .w-in', { yPercent: 110, rotate: 4, duration: 1.3, stagger: .07 })
      .from('[data-hero-visual]', { clipPath: 'inset(100% 0 0 0 round 22px)', duration: 1.5, ease: 'expo.inOut' }, 0.1)
      .from('[data-hero]', { y: 24, opacity: 0, duration: 1, stagger: .1 }, 0.5)
      .from('.nav-inner', { y: -20, opacity: 0, duration: .9 }, 0.3);
  }

  /* reveals */
  ScrollTrigger.batch('[data-reveal]', {
    start: 'top 88%', once: true,
    onEnter: els => gsap.to(els, { opacity: 1, y: 0, duration: 1.1, ease: 'expo.out', stagger: .08 })
  });

  /* servicios: pan horizontal en escritorio (se fija solo el bloque de tarjetas) */
  const mm = gsap.matchMedia();
  const pan = $('#pan'), wrap = $('#panWrap');
  if (pan && wrap) {
    mm.add('(min-width: 901px)', () => {
      const track = $('#panTrack');
      wrap.classList.add('pinned'); pan.scrollLeft = 0;
      const dist = () => track.scrollWidth - window.innerWidth;
      const tw = gsap.to(track, {
        x: () => -dist(), ease: 'none',
        scrollTrigger: {
          trigger: wrap, start: 'center center', end: () => '+=' + dist(),
          pin: wrap, pinSpacing: true, scrub: 1, invalidateOnRefresh: true,
          onUpdate: st => gsap.set('#panBar', { scaleX: st.progress })
        }
      });
      return () => { wrap.classList.remove('pinned'); tw.scrollTrigger && tw.scrollTrigger.kill(); gsap.set(track, { x: 0 }); };
    });
    mm.add('(max-width: 900px)', () => {
      gsap.from(pan, { x: 60, opacity: 0, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: pan, start: 'top 85%' } });
    });
  }

  /* manifiesto */
  const man = $('#manifesto');
  if (man) {
    splitWords(man, 'w');
    gsap.to($$('.w', man), { opacity: 1, stagger: .1, ease: 'none', scrollTrigger: { trigger: man, start: 'top 80%', end: 'bottom 45%', scrub: true } });
  }

  /* proceso: tarjetas apiladas */
  const steps = $$('.stack-card');
  steps.forEach((c, i) => {
    if (i === steps.length - 1) return;
    gsap.to(c, { scale: .92, '--dim': .65, ease: 'none', scrollTrigger: { trigger: steps[i + 1], start: 'top bottom', end: 'top 25%', scrub: true } });
  });

  /* CTA final */
  const ft = $('#finalTitle');
  if (ft) {
    splitWords(ft, 'w-in');
    gsap.from('#finalTitle .w-in', { scale: .6, opacity: 0, yPercent: 30, ease: 'expo.out', duration: 1.4, scrollTrigger: { trigger: ft, start: 'top 85%' } });
    gsap.fromTo('.final-glow', { scale: .5, opacity: 0 }, { scale: 1.1, opacity: 1, ease: 'none', scrollTrigger: { trigger: ft.closest('section'), start: 'top bottom', end: 'center center', scrub: true } });
  }

  /* botones magnéticos */
  if (matchMedia('(hover: hover)').matches) $$('.magnetic').forEach(el => {
    const xTo = gsap.quickTo(el, 'x', { duration: .6, ease: 'power3' });
    const yTo = gsap.quickTo(el, 'y', { duration: .6, ease: 'power3' });
    el.addEventListener('pointermove', e => { const r = el.getBoundingClientRect(); xTo((e.clientX - r.left - r.width / 2) * .3); yTo((e.clientY - r.top - r.height / 2) * .4); });
    el.addEventListener('pointerleave', () => { xTo(0); yTo(0); });
  });

  window.addEventListener('load', () => {
    ScrollTrigger.refresh();
    const t = location.hash && document.getElementById(location.hash.slice(1));
    if (t) { lenis ? lenis.scrollTo(t, { offset: -20, immediate: true }) : t.scrollIntoView(); requestAnimationFrame(() => ScrollTrigger.update()); }
  });
})();

/* ---------- shader: flujo líquido naranja que sigue al ratón ---------- */
function initFlow(canvas, still) {
  const gl = canvas.getContext('webgl', { antialias: false, premultipliedAlpha: false });
  if (!gl) return;
  const vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  const fs = `precision highp float;
  uniform vec2 r;uniform float t;uniform vec2 m;
  float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
  float n(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);
    return mix(mix(h(i),h(i+vec2(1,0)),u.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),u.x),u.y);}
  float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}
  void main(){
    vec2 uv=gl_FragCoord.xy/r;
    vec2 p=(gl_FragCoord.xy-.5*r)/min(r.x,r.y);
    p+=(m-.5)*.35;
    float tt=t*.07;
    vec2 q=vec2(fbm(p*1.5+tt),fbm(p*1.5-tt+3.1));
    vec2 w=vec2(fbm(p*1.7+q*2.4+vec2(1.7,9.2)+tt*1.3),fbm(p*1.7+q*2.4+vec2(8.3,2.8)-tt));
    float f=fbm(p*1.3+w*2.2);
    vec3 bg=vec3(.051,.051,.043);
    vec3 deep=vec3(.35,.09,.03);
    vec3 acc=vec3(1.,.357,.18);
    vec3 warm=vec3(.93,.92,.89);
    vec3 col=mix(bg,deep,smoothstep(.2,.5,f));
    col=mix(col,acc,smoothstep(.42,.78,f));
    col=mix(col,warm,smoothstep(.82,1.05,f+length(w)*.12)*.55);
    col*=1.-.4*length(uv-vec2(.5,.55));
    col+=(h(gl_FragCoord.xy+fract(t))-.5)*.035;
    gl_FragColor=vec4(col,1.);
  }`;
  const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
  const pr = gl.createProgram();
  gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs));
  gl.linkProgram(pr);
  if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
  gl.useProgram(pr);
  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);
  const loc = gl.getAttribLocation(pr, 'p');
  gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  const uR = gl.getUniformLocation(pr, 'r'), uT = gl.getUniformLocation(pr, 't'), uM = gl.getUniformLocation(pr, 'm');
  const mouse = { x: .5, y: .5, tx: .5, ty: .5 };
  const resize = () => {
    const dpr = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = canvas.clientWidth * dpr; canvas.height = canvas.clientHeight * dpr;
    gl.viewport(0, 0, canvas.width, canvas.height);
    if (still) draw(0);
  };
  const draw = now => {
    mouse.x += (mouse.tx - mouse.x) * .04; mouse.y += (mouse.ty - mouse.y) * .04;
    gl.uniform2f(uR, canvas.width, canvas.height);
    gl.uniform1f(uT, still ? 12 : now / 1000 + 12);
    gl.uniform2f(uM, mouse.x, mouse.y);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };
  new ResizeObserver(resize).observe(canvas); resize();
  if (still) return;
  window.addEventListener('pointermove', e => { mouse.tx = e.clientX / innerWidth; mouse.ty = 1 - e.clientY / innerHeight; }, { passive: true });
  let visible = true;
  new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(canvas);
  const loop = now => { if (visible) draw(now); requestAnimationFrame(loop); };
  requestAnimationFrame(loop);
}
